export function randomString(length: number): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charsLength = chars.length;
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * charsLength));
  }
  return result;
}

const TELEGRAM_NAME_FORBIDDEN_CHARS_REGEX =
  /[\u0000-\u001F\u007F-\u009F\u00AD\u061C\u200B\u200E\u200F\u202A-\u202E\u2060\u2066-\u2069\uFEFF]/g;

export function sanitizeTelegramDisplayName(value: unknown): string {
  if (typeof value !== 'string') {
    return '';
  }

  return value
    .normalize('NFC')
    .replace(TELEGRAM_NAME_FORBIDDEN_CHARS_REGEX, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function resolveTelegramDisplayName(primary: unknown, fallback: unknown = '-'): string {
  return sanitizeTelegramDisplayName(primary) || sanitizeTelegramDisplayName(fallback) || '-';
}

export function normalizeTelegramDisplayName(value: unknown): string {
  return sanitizeTelegramDisplayName(value).toLocaleLowerCase();
}
